<template>
  <div ref="popoverContainer" class="editor-popover" v-show="visible">
    <div v-if="error" class="mb-1">
      <Icon iconStyle="fas" icon="fa-exclamation-triangle" iconClass="text-danger" fixedWidth />
      <span class="text-danger ml-1">{{error}}</span>
    </div>
    <div class="editor-popover-content">
      <button class="editor-popover-close" @click.prevent="$emit('cancel')"><i class="far fa-times" /></button>
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.editor-popover {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 4px;
  min-width: 640px;
  min-height: 210px;
  padding: 0;
  border: 1px solid #d0d0d0;
  background-color: #f9f9f9;
  -webkit-box-shadow: 0 0 10px 0 rgba(74,53,107,.15);
  box-shadow: 0 0 10px 0 rgba(74,53,107,.15);
}
.theme-dark .editor-popover {
  background-color: #202020;
  border-color: #101010;
}

.editor-popover-content {
  padding: 4px;
  position: relative;
}

.editor-popover,
.editor-popover .form-control,
.editor-popover .input-group-addon {
  font-size: 12px;
}
.editor-popover .form-group {
  margin-bottom: 0.25rem;
}

.editor-popover-title {
  font-weight: 600;
  text-align: center;
  margin-top: -6px;
  margin-bottom: 6px;
}
.editor-popover-button {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  /*font-weight: 600;*/
  font-size: 0.85rem;
}

.editor-popover-buttontype-edit {
  color: inherit;
}
.editor-popover-buttontype-update {
  color: $status-approved;
}
.editor-popover-buttontype-remove {
  color: $status-denied;
}
.editor-popover-buttontype-action {
  color: $status-mixed;
}

.editor-popover .nav-tabs > li > a {
  padding: 9px 18px 9px 12px;
  font-size: 13px;
}
.editor-popover .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #464c54;
}
.editor-popover .tab-content .panel-body {
  padding: 10px;
  min-height: 170px;
}

.editor-popover-close {
  position: absolute;
  right: 2px;
  top: 2px;
  border: 0;
  padding: 0.25rem 0.5rem;
  background-color: transparent;
  font-size: 1.10rem;
  font-weight: bold;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.25;
  cursor: pointer;
}
.theme-dark .editor-popover-close {
  color: #B0B0B0;
  text-shadow: 0 1px 0 #000000;
}


</style>

<script>
import EditorPopoverMixin from '../mixins/editorPopover'
import { PopoverPositions } from '@glass-designer/types'

export default {
  name: 'EditorPopover',
  mixins: [EditorPopoverMixin],
  props: {
    error: String,
    title: String,
    showButtons: {
      type: Boolean,
      default: true
    },
    actionButtons: Array
  },
  data() {
    return {
      visible: false,
      worldPosition: null
    }
  },
  computed: {
    actionButtonList() {
      return this.actionButtons || []
    },
    buttonColumnSize() {
      return Math.floor(12 / (1 + (this.actionButtons || []).length))
    }
  },
  beforeDestroy() {
  },
  mounted() {
  },
  methods: {
    displayFromWorldPosition(containerEl, editor, worldPosition) {
      this.worldPosition = worldPosition.clone()
      let screenPos = editor.projectWorldCoordinate(this.worldPosition)
      this.visible = true

      this.$nextTick(() => {
        this.adjustPosition(containerEl, this.$refs.popoverContainer, screenPos.x, screenPos.y)
      })
    },
    displayToolPopover(containerEl, editor, displayOptions) {
      this.visible = true

      this.$nextTick(() => {
        let popoverMargin = editor.settings.isTouchDevice ? 25 : 15
        let editorWidth = containerEl.offsetWidth
        let editorHeight = containerEl.offsetHeight
        let popoverWidth = this.$refs.popoverContainer.offsetWidth
        let popoverHeight = this.$refs.popoverContainer.offsetHeight

        var targetX = Math.round(editorWidth / 2 - popoverWidth / 2)
        var targetY = editorHeight - popoverHeight - popoverMargin

        if(displayOptions) {
          if(displayOptions.horizontalPosition == PopoverPositions.left)
            targetX = popoverMargin
          else if(displayOptions.horizontalPosition == PopoverPositions.right)
            targetX = Math.round(editorWidth - popoverWidth - popoverMargin)
        }

        this.$refs.popoverContainer.style.left = `${(targetX)}px`
        this.$refs.popoverContainer.style.top = `${targetY}px`
      })
    },
    viewportUpdated(containerEl, editor) {
      let screenPos = editor.projectWorldCoordinate(this.worldPosition)
      
      this.adjustPosition(containerEl, this.$refs.popoverContainer, screenPos.x, screenPos.y)
    },
    hide() {
      this.visible = false
    },
    actionButtonClass(buttonType) {
      var classMap = {
        edit: 'editor-popover-buttontype-edit',
        action: 'editor-popover-buttontype-action',
        update: 'editor-popover-buttontype-update',
        remove: 'editor-popover-buttontype-remove'        
      }
      return classMap[buttonType] || 'status-approved'
    }
    
  }
}
</script>